type Environment = 'development' | 'homolog' | 'production';

interface EnvironmentConfig {
  name: string;
  label: string;
  shortLabel: string;
  color: string;
  bgColor: string;
  borderColor: string;
}

const ENV_CONFIGS: Record<Environment, EnvironmentConfig> = {
  development: {
    name: 'development',
    label: 'Ambiente de Desenvolvimento',
    shortLabel: 'DEV',
    color: 'text-amber-800',
    bgColor: 'bg-gradient-to-r from-amber-50 to-yellow-50',
    borderColor: 'border-amber-200',
  },
  homolog: {
    name: 'homolog',
    label: 'Ambiente de Homologação',
    shortLabel: 'HML',
    color: 'text-[#422534]',
    bgColor: 'bg-gradient-to-r from-[#422534]/5 to-[#422534]/10',
    borderColor: 'border-[#422534]/20',
  },
  production: {
    name: 'production',
    label: 'Produção',
    shortLabel: 'PROD',
    color: 'text-green-700',
    bgColor: 'bg-green-50',
    borderColor: 'border-green-200',
  },
};

export const getEnvironment = (): Environment => {
  const env = (import.meta.env.VITE_REACT_ENV as string)?.trim()?.toLowerCase();

  if (env === 'development') return 'development';
  if (env === 'homolog' || env === 'homologation') return 'homolog';
  return 'production';
};

export const getEnvironmentConfig = (): EnvironmentConfig => {
  return ENV_CONFIGS[getEnvironment()];
};

export const isProduction = (): boolean => {
  return getEnvironment() === 'production';
};

export const isDevelopment = (): boolean => {
  return getEnvironment() === 'development';
};

export const isHomolog = (): boolean => {
  return getEnvironment() === 'homolog';
};

export const getPageTitle = (suffix?: string): string => {
  const env = getEnvironment();
  const baseTitle = 'Retaguarda';

  if (env === 'production') {
    return suffix ? `${baseTitle} | ${suffix}` : baseTitle;
  }

  const envLabel = ENV_CONFIGS[env].shortLabel;
  return suffix ? `${baseTitle} | ${envLabel} | ${suffix}` : `${baseTitle} | ${envLabel}`;
};
